import { render, staticRenderFns } from "./WorkflowPane.vue?vue&type=template&id=49d988e1&"
import script from "./WorkflowPane.vue?vue&type=script&lang=ts&"
export * from "./WorkflowPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports